(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["saucisse-pairings"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sc-product-pairings')) {
  customElements.define('sc-product-pairings', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); this.load(); }
      }, {rootMargin:'600px'});
      observer.observe(this);
    }
    design(title) {
      return title.toLowerCase().replace(/dacshsund/g,'dachshund').replace(/t[ -]?shirts?|phone cases?|tote bags?|hoodies?|sweatshirts?|sweaters?|bandanas?|mugs?|caps?/g,' ').replace(/\b(new|unisex|womens|women|mens|men|kids|small|large|high|gloss|coloured|premium|saucisse|outlet)\b/g,' ').replace(/[^a-z0-9 ]/g,' ').replace(/\s+/g,' ').trim();
    }
    category(title) {
      return (title.toLowerCase().match(/phone ?case|t[ -]?shirt|tote|shopping bag|mug|bandana|cap|hoodie|sweater|sweatshirt|rucksack|beanie|joggers/)||['other'])[0].replace('t shirt','t-shirt').replace('phonecase','phone case').replace('shopping bag','tote');
    }
    async load() {
      const grid=this.querySelector('.sc-pair-grid');
      const fallback=Array.from(this.querySelector('template').content.querySelectorAll('.sc-pair-card'));
      let candidates=Array.from(grid.children);
      const key=this.design(this.dataset.title);
      if(this.dataset.manual!=='true' && key.length>3) {
        try {
          const url=new URL(this.dataset.search,location.origin);
          url.searchParams.set('q',key);
          url.searchParams.set('resources[type]','product');
          url.searchParams.set('resources[limit]','10');
          url.searchParams.set('resources[options][fields]','title');
          url.searchParams.set('resources[options][unavailable_products]','hide');
          url.searchParams.set('section_id','saucisse-pair-search');
          const response=await fetch(url,{credentials:'same-origin'});
          if(!response.ok) throw new Error('Search unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          candidates=Array.from(doc.querySelectorAll('.sc-pair-card')).filter(card=>this.design(card.dataset.title)===key && !/outlet/i.test(card.dataset.title));
          const priorities=['phone case','t-shirt','tote','mug','bandana','cap','sweater','sweatshirt','hoodie','other'];
          candidates.sort((a,b)=>priorities.indexOf(this.category(a.dataset.title))-priorities.indexOf(this.category(b.dataset.title)));
        } catch(error) { candidates=[]; }
      }
      const selected=[]; const ids=new Set([this.dataset.current]); const types=new Set([this.category(this.dataset.title)]);
      for(const pool of [candidates,fallback]) {
        for(const card of pool) {
          const type=this.category(card.dataset.title);
          if(ids.has(card.dataset.id)||types.has(type)||selected.length===3) continue;
          selected.push(card.cloneNode(true));ids.add(card.dataset.id);types.add(type);
        }
      }
      grid.replaceChildren(...selected);
      this.hidden=selected.length===0;
      this.dataset.loaded='true';
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
